import { Component, OnInit, Input, AfterViewInit, ChangeDetectorRef, OnDestroy, ChangeDetectionStrategy, Output, EventEmitter, ViewChild, ViewContainerRef } from '@angular/core';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { DialogConfig } from '../../../dialog/dialog-config';
import { DialogModalSize } from '../../../dialog/dialog-ref';
import { AIService } from '../../services/ai.service';
import { HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
declare var mermaid: any;
declare var Chart: any;
declare var ace: any;
import { isEqual } from "lodash";

@Component({
    selector: 'app-kx-ai-model',
    templateUrl: './kx-ai-model.component.html',
    styleUrls: ['./kx-ai-model.component.scss'],
    standalone: false
})
export class KxAIModelComponent implements OnInit, AfterViewInit, OnDestroy {
  config: any = { builderMode:"ai_summary",defaultViewMode:false,loaded: false, noData: false, outputType: "html", errMsg: "",currentTemplate:"" ,instructions:[],documentId:'',loadView:false,csvAnalyse:false};
  analyticsData: {
    summary?: string;
    charts?: any[];
    timestamp?: string;
  } = {};
  activeTab: string = 'analysis';
  activeCodeTab:string = 'generated'
  activeQueryTab:string = 'code'
  isDropdownOpen: boolean = false;
  builderForm: FormGroup;
  showSecondField: boolean = false;
  secondFieldValue: string = '';
  data: any = { editingAvailable: false };
  chartInstances: any[] = [];
  showTabs: boolean = false;
  editor: any;
  editorInitialized: boolean = false;
  editorJson: any;
  editorInitializedJson: boolean = false;
  samplePythonScript: string = `# Sample Python script`;
  fieldNames: string = '';
  builderAllowed: boolean = false;
  @Output() getData: EventEmitter<any> = new EventEmitter();//for outputting general configration
  @ViewChild('customComponent', { read: ViewContainerRef }) customComponent!: ViewContainerRef;
  insightsCollapsed = false;

  constructor(
    public rolePermissionService: RolePermissionService,
    public baseService: BaseService,
    public alertService: AlertsService,
    public loader: LoaderService,
    public aiService: AIService,
    public dialogConfig: DialogConfig,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder
  ) {    
    this.builderForm = this.fb.group({
      prompt: ['', [Validators.required, this.latin1Validator()]],
      prompt_master: ['', [this.latin1Validator()]],
      code: [this.samplePythonScript]
    });
  }

  ngOnInit(): void {
    this.initializeComponent();
  }

  getCurrentPromptConfig(prompt_config){
    
    for (let index = 0; index < prompt_config.length; index++) {
      const element = prompt_config[index];
      if(element.template_name != undefined && ((element.isFeatureAvailable != undefined && element.isFeatureAvailable) ||  (this.data.gridConfig.editing != undefined && this.data.gridConfig.editing) ) ){
        if(this.config.currentTemplate == ""){
          this.config.currentTemplate = element.template_name 
          return element;
        }else if(element.template_name == this.config.currentTemplate){
          return element;
        }        
      }
    }
    return false;
  }

  private initializeComponent(): void {
    if (this.dialogConfig?.data?.aiData == undefined) {
      var resource = this.dialogConfig?.data?.action?.resource
      var aiFeature = false;
      if (this.dialogConfig?.data?.action.feature != undefined) {
        aiFeature = this.dialogConfig?.data?.action.feature
      }
      this.aiService.checkIfAIAvailable({ resource: resource }, aiFeature, (respData) => {
        console.log(respData);
        
          var resourceApp = this.dialogConfig?.data.menuData.application
          var currentResource = this.dialogConfig?.data.menuData.current_resource
          var config: any = {};
          var data: any = {};
          this.baseService.getResourceDef(currentResource, (resouceDef) => {
            if (resouceDef) {
              this.aiService.checkIfAIAvailable(resouceDef, AIService.AI_REPORT, (aiResp) => {
                if (aiResp.config == undefined) {
                  aiResp.config = {}
                }
                if (aiResp.config.ai == undefined) {
                  aiResp.config.ai = {}
                  aiResp.config.ai.grid = {}
                  aiResp.config.ai.grid.prompt_config = []
                }
                if (aiResp.config?.ai != undefined) {
                  if (aiResp.config.ai.grid == undefined) {
                    aiResp.config.ai.grid = {}
                  }
                  if (aiResp.config.ai.grid.prompt_config == undefined) {
                    aiResp.config.ai.grid.prompt_config = []
                  }
                  if(respData && Array.isArray(respData) && respData.length>0){
                    aiResp.config.ai.grid.prompt_config.push({
                      "prompt_code": respData[0].prompt_code,
                      "output_mode": respData[0].output_mode,
                      "ai_feature_code": AIService.ASK_YOUR_DATA,
                      "template_name": "Ask Your Data",
                      "ai_agent":respData[0].ai_agent
                    })
                  }
                 
                  config.resourceDef = aiResp;
                  config.dynamic_key = aiResp.resource;
                  config.filter = "";
                  config.configLoaded = true
                  this.aiService.initAiSummary(config, data, resourceApp)
                  this.dialogConfig.data.aiData = data;
                  this.dialogConfig.data.config = config;
                  this.config.csvAnalyse = this.dialogConfig?.data.menuData
                  this.initData();
                }
              })
            }
          });
        
      },false);

    } else {
      this.initData();
    }


  }
  private initData(){
    this.config.loadView = true
    if (this.dialogConfig?.data?.aiData?.gridConfig) {
      this.data.gridConfig = this.dialogConfig.data.aiData.gridConfig;
      if (this.data.gridConfig?.prompt_config != undefined) {
        if(this.config.csvAnalyse){

        }
        this.data.gridConfig.prompt_config_current = this.getCurrentPromptConfig(this.data.gridConfig?.prompt_config );
        this.setBuilderMode();
      }
      if (this.data.gridConfig?.prompt_config_current) {
        if (this.data.gridConfig?.prompt_config_current?.python_file) {
          this.config.errMsg = "Script file already configured for resource: " + this.dialogConfig?.data?.config?.resourceDef?.resource;
        } else {
          this.builderAllowed = true;
        }
      } else {
        this.config.errMsg = "Kindly create Prompt for resource: " + this.dialogConfig?.data?.config?.resourceDef?.resource;
      }
    }

    if (this.dialogConfig?.data?.aiData?.editingAvailable) {
      this.data.editingAvailable = this.dialogConfig.data.aiData.editingAvailable;
      this.aiService.getPromptInstructions((instructions)=>{
          if(instructions){
            this.config.instructions = instructions
          }
      })
      this.showTabs = this.data.editingAvailable;
    }

    if (this.dialogConfig?.data?.config) {
      this.data.compConfig = this.dialogConfig.data.config;
      this.extractFieldNames();
      this.initPromptBuilder();
    }

    if (this.data.gridConfig?.prompt_config_current || this.data.gridConfig?.full_prompt_code || this.data.gridConfig?.prompt_code) {
      this.getSummary();
    } else {
      this.activeTab = 'builder';
      this.config.loaded = true;
      this.config.noData = true;
    }
  }

  initPromptBuilder(){      
      if(this.data.compConfig?.resourceDef?.config?.ai?.grid?.mode != undefined){
        this.config.defaultViewMode = this.data.compConfig?.resourceDef?.config?.ai?.grid?.mode === 'table';
      }else if (this.data.gridConfig?.prompt_config_current?.output_mode != undefined && this.data.gridConfig?.prompt_config_current?.output_mode != ""){
        this.config.defaultViewMode = this.data.gridConfig?.prompt_config_current?.output_mode === 'table';
      }      
      this.initializePromptTemplate();
  }

  getCurrentInstructionsPrompt(){
    if(this.config.builderMode == "ai_report"){
      //ToDO MAKE FIELDNAME FROM CSV
      if(this.activeQueryTab == 'code'){
        return AIService.INSTRUCTIONS_CODE[1];
      }else{
        return AIService.INSTRUCTIONS_CODE[2];
      }      
    }else{
      return AIService.INSTRUCTIONS_CODE[0];
    }
  }
  private initializePromptTemplate(): void {
    var template="";
    var instructionCode = this.getCurrentInstructionsPrompt()
    if(this.config.builderMode == "ai_report"){
      //ToDO MAKE FIELDNAME FROM CSV
      if(this.activeQueryTab == 'code'){
        if(this.config.instructions[instructionCode] != undefined){
          template = this.config.instructions[instructionCode]
        }
        template = template.replace("{SCHEMA}",JSON.stringify(this.data.gridConfig.prompt_config_current.schema_content))
      }else{
        if(this.config.instructions[instructionCode] != undefined){
          template = this.config.instructions[instructionCode]
        }
      }      
    }else{
      if(this.config.instructions[instructionCode] != undefined){
        template = this.config.instructions[instructionCode]
      }
    }
    template = template.replace("{FIELDS}",this.fieldNames)
    this.builderForm.get('prompt')?.setValue(template);
  }

  ngAfterViewInit(): void {
    if (this.activeTab === 'builder') {
      this.initializeEditor(false);
    }
  }

  private initializeEditor(callback): void {
    var promptValue;
    var value;
    if(this.data.gridConfig?.prompt_config_current?.script != undefined && this.data.gridConfig?.prompt_config_current?.script != ""){
      value = this.data.gridConfig?.prompt_config_current?.script, -1;
    }else{
      value = this.samplePythonScript;
    }
    if(this.config.builderMode == "ai_report"){
      var valueJSON = "{}";
      if(this.data.gridConfig?.prompt_config_current?.schema_content == undefined && this.data.gridConfig?.prompt_config_current?.schema != undefined){
          this.aiService.getPromptSchema(this.data.gridConfig?.prompt_config_current?.schema,(resp)=>{
            try{
              this.data.gridConfig.prompt_config_current.schema_content = JSON.parse(resp[0].dynamic_key)
              valueJSON = JSON.stringify(this.data.gridConfig.prompt_config_current.schema_content, null, 2);
            }catch(e){
              console.warn(e)
            }
            this.initializeAceEditor('schema-editor','ace/mode/json',valueJSON,(editorRef)=>{
              this.editorJson= editorRef;
              this.editorInitializedJson = true;
              this.initializeCodeEditor(callback,value)   
            })
          })
      }else{
        valueJSON = JSON.stringify(this.data.gridConfig.prompt_config_current.schema_content, null, 2);
        this.initializeAceEditor('schema-editor','ace/mode/json',valueJSON,(editorRef)=>{
          this.editorJson= editorRef;
          this.editorInitializedJson = true;
          this.initializeCodeEditor(callback,value)   
        })
      }
    }else{
      if(this.data.gridConfig?.prompt_config_current?.prompt != undefined && this.data.gridConfig?.prompt_config_current?.prompt != ""){
        promptValue = this.data.gridConfig?.prompt_config_current?.prompt;
      }else{
        promptValue = "";
      }
      this.builderForm.get('prompt_master')?.setValue(promptValue);
      this.initializeCodeEditor(callback,value)   
    }
  }

  initializeCodeEditor(callback,value){
    this.initializeAceEditor('code-editor','ace/mode/python',value,(editorRef)=>{
      this.editor= editorRef;
      this.editorInitialized = true;
      if(callback){
        callback(true)
      }
    })
  }


  private initializeAceEditor(aceId,aceMode,aceValue,callback): void {
    if (typeof ace === 'undefined') return;

    const editorElement = document.getElementById(aceId);
    if (!editorElement) return;
    var editorRef;
    try {
      if (editorRef) {
        editorRef.destroy();
        editorRef = null;
      }

      editorRef = ace.edit(aceId);
      editorRef.setTheme('ace/theme/chrome');
      editorRef.session.setMode(aceMode);
      editorRef.setValue(aceValue || '', -1);
      
      editorRef.setOptions({
        fontSize: '14px',
        showPrintMargin: false,
        showGutter: true,
        highlightActiveLine: true,
        showLineNumbers: true,
        tabSize: 4,
        useSoftTabs: true,
        cursorStyle: 'smooth',
        cursorBlinkRate: 530,
        cursorWidth: 2,
        selectionStyle: 'line',
        highlightGutterLine: true,
        highlightSelectedWord: true,
        behavioursEnabled: true,
        wrapBehavioursEnabled: true,
        autoScrollEditorIntoView: true,
        copyWithEmptySelection: true,
        enableAutoIndent: true,
        enableMultiselect: true,
        enableBlockSelect: true,
        enableBasicAutocompletion: true,
        enableLiveAutocompletion: true,
        enableSnippets: true,
        useTextareaForIME: true,
        mergeUndoDeltas: true,
        scrollPastEnd: 0.5,
        foldStyle: 'markbegin',
        showFoldWidgets: true,
        fadeFoldWidgets: true,
        fixedWidthGutter: true,
        showIndentGuides: true,
        showInvisibles: false,
        useWorker: true
      });

      const resizeObserver = new ResizeObserver(() => {
        if (editorRef) {
          editorRef.resize();
        }
      });
      resizeObserver.observe(editorElement);

      setTimeout(() => {
        if (editorRef) {
          editorRef.resize();
          editorRef.gotoLine(1, 0, false);
          editorRef.focus();
          editorRef.getSession().setUseWorker(true);
          editorRef.getSession().setMode('ace/mode/python');
          callback(editorRef)
        }
      }, 50);

     
    } catch (error) {
      console.error('Error initializing Ace editor:', error);
      callback(false)
    }
  }

  switchTab(tab: string): void {
    this.activeTab = tab;
    if (tab === 'builder') {
      this.editorInitialized = false;
      this.editorInitializedJson = false;
      setTimeout(() => {
        this.initializeEditor(() => {
          this.initializePromptTemplate();
          setTimeout(() => {
            if (this.editor) this.editor.resize();
            if (this.editorJson) this.editorJson.resize();
          }, 50);  // small delay to let DOM render
        });
        
      }, 100);
    }
  }
  switchCodeTab(tab: string): void {
    this.activeCodeTab = tab;
  }
  switchQueryTab(tab: string,init=true): void {
    this.activeQueryTab = tab;
    if(init){
      this.initializePromptTemplate()
    }
      
    if(tab == 'code'){
      this.switchCodeTab('generated')
    }else{
      this.switchCodeTab('prompt')
      this.createScanInput()
    }
  }


  initAIOutput(summary: any,schema:any=false): void {
    if (summary) {
      const parsedSummary = this.parseLLMOutput(summary);
      if(this.data.gridConfig.prompt_config_current != undefined && this.data.gridConfig.prompt_config_current.ai_feature_code != undefined){
        switch (this.data.gridConfig.prompt_config_current.ai_feature_code) {
          case "ai_report":
            this.config['outputType'] = this.data.gridConfig.prompt_config_current.ai_feature_code;
            this.config['schema'] = schema;
            this.config['menuData'] = this.dialogConfig?.data.menuData;
            break;
        
          default:
            if(['component'].indexOf(this.data.gridConfig?.prompt_config_current?.output_mode)>-1){
              this.config['outputType'] = this.data.gridConfig?.prompt_config_current?.output_mode;
              this.config['selector'] =  this.data.compConfig.resourceDef.config?.ai?.selector;
            }else{
              this.config['outputType'] =  parsedSummary?.charts ? "chart" : "html";
            }
            
            break;
        }
      }else{
        this.config['outputType'] =  parsedSummary?.charts ? "chart" : "html";
      }
      // Create a new config object to ensure change detection
      this.config = {
        ...this.config,
        summary: parsedSummary,
        loaded: true,
        noData: false
      };
     
    } else {
      this.config = {
        ...this.config,
        loaded: true,
        noData: true
      };
    }
  }

  private parseLLMOutput(rawOutput: string): any {
    try {
      return this.aiService.parseLLMJsonResponse(rawOutput)
    } catch (error) {
      return this.sanitizer.bypassSecurityTrustHtml(rawOutput.trim());
    }
  }

  private fixEncoding(str: string): string {
    try {
      return decodeURIComponent(escape(str));
    } catch (err) {
      return str;
    }
  }

  createScanInput(){
    setTimeout(()=>{
      this.createComponent('dhs-file-uploader');
    },50)
  }

  deleteImage(event) {
    this.config.documentId = "";
  }

  onSaveFinished(event) {
    if(event.documentId != undefined){
      this.config.documentId = event.documentId;
    }else{
      this.config.documentId = "";
    }
  }
  createComponent(kxselector: any, input?) {
    setTimeout(() => {
      this.customComponent.clear();
      this.baseService.createComponent(kxselector, this.customComponent, (response) => {
        if (response) {
          response.instance.focus_out.subscribe((data)=>{
            this.onSaveFinished(data);
          });
          response.instance.delete.subscribe((data)=>{
            this.deleteImage(data);
          });
          response.instance.resource = 'ai_scan'
          response.instance.maxSize = 15
          response.instance.crop_image = false
        }
      })
    })
  }

  onSubmitPrompt(): void {
    if (this.builderForm.valid) {
      //#TODO multiple prompt support
      var filter = "";
      if(this.config.builderMode == "ai_report"){
        if(this.activeQueryTab == 'code'){
          this.switchQueryTab('code',false)
          if(this.data.gridConfig?.prompt_config_current.schema == undefined || this.data.gridConfig?.prompt_config_current.schema == ""){
            this.alertService.error("Please prepare the schema first.")
            this.switchQueryTab('schema',false)
            return;
          }
          if(this.config.csvAnalyse){
            filter = "download_id:"+this.config.csvAnalyse.id+",download_url:"+btoa(this.config.csvAnalyse.url);
          }
        }else{
          if(this.config.documentId == undefined || this.config.documentId == ""){
            this.alertService.error("Please upload the report screenshot")
            return;
          }else{
            filter = "documentId:"+this.config.documentId
          }
        }      
      }else{
        this.switchQueryTab('code',false)
      }
      const promptValue = this.builderForm.get('prompt').value;
      const encodedPrompt = this.aiService.encodeToLatin1(promptValue);
      var instructionCode = this.getCurrentInstructionsPrompt()
      this.aiService.getPromptResponse(instructionCode, "prompt_response", encodedPrompt,filter, (promptResp) => {  
        var editorRef; 
        if(this.config.builderMode == "ai_report"){
          if(this.activeQueryTab == 'code'){
            editorRef = this.editor;
          }else{
            editorRef = this.editorJson;
            promptResp = JSON.stringify(promptResp, null, 2);
          }      
        }else{
          editorRef = this.editor;
        }

        if (editorRef && promptResp) {                        
          editorRef.setValue(promptResp,-1);
          editorRef.clearSelection();
          editorRef.resize();
          this.alertService.success("Success")
        } else {
          this.alertService.error("Code generation error");
        }
      });
    } else if (this.builderForm.get('prompt').errors?.['latin1']) {
      this.alertService.error('Only Latin1/ISO-8859-1 characters are allowed');
    }
  }


  jsonToBase64DataURL(jsonString: string): string {
    const base64 = btoa(unescape(encodeURIComponent(jsonString)));
    return `data:application/json;base64,${base64}`;
  }
  
  uploadSchema(schema,fileName,callback) {
    this.loader.showSpinner();
  
    let docType = "ai_analysis";
  
    const fd = new FormData();
    fd.append('action', 'add');
    const jsonBlob = new Blob([schema], { type: 'application/json' });
    fd.append('fileName', fileName);
    fd.append('file', jsonBlob,fileName);
  
    this.baseService.upload(fd, 'dms', docType, this.jsonToBase64DataURL(schema)).subscribe(res => {
      console.log('Upload success:', res);
      this.loader.hideSpinner();
      if (res.errCode === 0 && res.resource?.length > 0) {
        callback(res.resource[0])
      }else{
        console.error('Upload failed:');
        callback(false)
      }
      
    }, err => {
      console.error('Upload failed:', err);
      this.loader.hideSpinner();
      callback(false)
    });
  }

  onSaveCode(): void {
    var editorRef;
    if(this.config.builderMode == "ai_report"){
      if(this.activeQueryTab == 'code'){
        editorRef = this.editor;
        const code = editorRef.getValue();
        this.savePromptData(editorRef,code,null,null,null);
      }else{
        editorRef = this.editorJson;
        var schema = editorRef.getValue();
        try{
         var schemaObj = JSON.parse(schema)
         if(isEqual(schemaObj,this.data.gridConfig?.prompt_config_current.schema_content)){
            this.alertService.info("There is no change is schema.");
            return;
         }
        }catch(e){

        }
        var fileName = this.data.gridConfig?.prompt_config_current?.template_name+".json"
        this.uploadSchema(schema,fileName,(resp)=>{
          if(resp){
            this.savePromptData(editorRef,null,null,schema,resp.document_id)
          }else{
            this.alertService.error("Schema Upload fail")
          }
        })
      }      
    }else{
      editorRef = this.editor;
      const code = editorRef.getValue();
      var prompt = this.builderForm.get('prompt_master').value;
      this.savePromptData(editorRef,code,prompt,null,null)
    }
  }

  savePromptData(editorRef,code,prompt,schema_content,schemaId): void {
    if (editorRef) {
      this.loader.showSpinner();
      this.aiService.updateScript(this.data.gridConfig?.prompt_config_current?.resource,code,prompt,this.data.gridConfig?.prompt_config_current?.template_name,schemaId,(resp)=>{
        this.loader.hideSpinner();
        if(resp){
          this.alertService.success("Success")
          if(prompt){
            this.data.gridConfig.prompt_config_current.prompt = prompt
          }
          if(code){
            this.data.gridConfig.prompt_config_current.script = code
          } 
          if(schema_content){
            this.data.gridConfig.prompt_config_current.schema_content = JSON.parse(schema_content)
          }
          if(schemaId){
            this.data.gridConfig.prompt_config_current.schema = schemaId
          }          
          
          this.initializeComponent();
          this.switchTab('analysis')
          this.getData.emit({"type":"prompt_config_current","obj": this.data.gridConfig.prompt_config_current});            
        }
      })
      
    }
  }

  getSummary(): void {
    if (this.config.loading) return;
    
    this.config.loading = true;
    this.config.loaded = false;    
    this.config.askData = false;    
   
    if(this.data.gridConfig.prompt_config_current != undefined && (this.data.gridConfig.prompt_config_current.ai_feature_code == AIService.ASK_YOUR_DATA || this.data.gridConfig.prompt_config_current["ai_agent"][0]["id"]== AIService.ASK_YOUR_DATA)){
      this.config.outputType =  AIService.ASK_YOUR_DATA
      this.config.loading = false;
      this.config.loaded = true;
      this.config.askData = true;
      this.config.summary = null;
      this.config.llm_name = this.data.gridConfig.prompt_config_current.llm_name;
      this.config.model = this.data.gridConfig.prompt_config_current.model;
      this.config = { ...this.config };//totriger outuput component
      return;
    }

    
    this.config = { ...this.config };//totriger outuput component
    const datasource:any = this.aiService.getDatasourceByAiConfig(this.data.compConfig, this.data.gridConfig);
    datasource.headers = { "headers": new HttpHeaders().set('timeout', "120000") };
    if(this.config.csvAnalyse){
      let newArgs = "download_id:"+this.config.csvAnalyse.id+",download_url:"+btoa(this.config.csvAnalyse.url);
      if(datasource.args == undefined || datasource.args == ""){
        datasource.args = newArgs
      }else{
        datasource.args = datasource.args+","+newArgs
      }
    }
    this.baseService.getByDataSource(datasource).subscribe(
      (data) => {
        this.config.loading = false;
        if (data.errCode === 0 && data.resource?.length > 0) {
          const message = atob(data.resource[0].message);
          var schema:any = false;
          try{
            if(data.resource[0].filter != undefined){
              schema = JSON.parse(atob(data.resource[0].filter));
            }
          }catch(e){
            console.warn(e)
          }
          const type = data.resource[0].type;
          this.showSummary(type, message,schema);
        } else {
          this.initAIOutput(false)
          this.alertService.error(data.message);
        }
      },
      error => {
        this.initAIOutput(false)
        this.config.loading = false;
        this.alertService.error(error);
      }
    );
  }

  showSummary(type: string, summary: string,schema:any): void {
    // Create a new object to ensure change detection
    this.initAIOutput(summary,schema);
    // Force change detection by creating a new reference
    this.config = { ...this.config };
  }

  ngOnDestroy(): void {
    if (this.editor) {
      this.editor.destroy();
      this.editor = null;
    }
    if (this.editorJson) {
      this.editorJson.destroy();
      this.editorJson = null;
    }
  }

  private extractFieldNames(): void {
    if (this.data.compConfig?.resourceDef?.list?.fields) {
      const fields = this.data.compConfig.resourceDef.list.fields;
      this.fieldNames = fields
        .map(field => field.name)
        .filter(name => name)
        .join(', ');
    }
  }

  private latin1Validator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;

      try {
        const encoded = encodeURIComponent(value);
        const decoded = decodeURIComponent(encoded);
        return value === decoded ? null : { latin1: true };
      } catch {
        return { latin1: true };
      }
    };
  }

  

  onTextareaInput(id,event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    const value = textarea.value;
    const encodedValue = this.aiService.encodeToLatin1(value);
    if (value !== encodedValue) {
      this.builderForm.get(id).setValue(encodedValue);
    }
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectTemplate(templateName: string): void {
    if (this.config.loading) return;
    this.config.currentTemplate = templateName;
    this.isDropdownOpen = false;
    // Update the current prompt config
    if (this.data.gridConfig?.prompt_config) {
      this.data.gridConfig.prompt_config_current = this.getCurrentPromptConfig(this.data.gridConfig.prompt_config);
      this.setBuilderMode();
      this.getSummary();
      this.initPromptBuilder();
      if (this.activeTab === 'builder') {
        this.switchTab(this.activeTab)
      }
    }
  }

  setBuilderMode(){
    this.config.builderMode = this.data.gridConfig.prompt_config_current.ai_feature_code
  }
}